import * as actionTypes from './actionTypes';

export const alertAdd = (alert) => {
    return {
        type: actionTypes.ALERT_ADD,
        alert: alert
    };
};
